import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "scan-identify",
  "use": "scan-identify-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"scan-identify\"><path d=\"M2.182 18.545H0V24h5.455v-2.182H2.182zM0 5.455h2.182V2.182h3.273V0H0zm21.818 16.363h-3.273V24H24v-5.455h-2.182zM18.545 0v2.182h3.273v3.273H24V0zM15.752 14.801l3.278 3.279-.95.95-3.279-3.278a5.77 5.77 0 1 1 .95-.95zm-4.528.835a4.412 4.412 0 1 0 0-8.824 4.412 4.412 0 0 0 0 8.824z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol